import { gql } from 'apollo-angular';

const GET_EXECUTE_RFP_STATISTICS = gql`
  query getRfpStatistics($organizationId: Long) {
    rfpStatistics(organizationId: $organizationId) {
      responseDueCount
      prcExpiresWithinTenDaysCount
      prcExpiresWithinElevenToTwentyDaysCount
      prcExpiresWithinTwentyOneToSixtyDaysCount
    }
  }
`;

export default GET_EXECUTE_RFP_STATISTICS;
